import React, { createContext, useContext, useReducer } from 'react'

const initialVisualState = {
	backgroundStyle: "fullwidth", // "default","fullwidth","inverted", "hidden"
	transitionState: null, // null, "transitionOut",
}

const VisualContext = createContext(initialVisualState);

const visualReducer = (state, action) => {
	const { type, payload } = action
	
	switch(type) {
		
		case "CHANGE_TRANSITION_STATE":
			console.log("CHANGE_TRANSITION_STATE", payload)

			return {
				...state,
				transitionState: payload
			}
		
			case "SET_BG_STYLE":
			console.log("SET_BG_STYLE", payload)

			return {
				...state,
				backgroundStyle: payload
			}
		
		default:
			throw new Error(`No case for type: ${type} found in visualReducer`)
	}
}

const VisualProvider = ({children}) => {
	
	const [state, dispatch] = useReducer(visualReducer, initialVisualState)

	const setBGStyle = (style) => {
		dispatch({
			type: "SET_BG_STYLE",
			payload: style
		})
	}

	const setTransition = (transition)=>{
		dispatch({
			type: "CHANGE_TRANSITION_STATE",
			payload: transition
		})
	}

	const providerValue = {
		transitionState: state.transitionState,
		backgroundStyle: state.backgroundStyle,
		setBGStyle,
		setTransition,
	}

	return (
		<VisualContext.Provider value={providerValue}>
			{children}
		</VisualContext.Provider>
	)
}

const useVisualContext = () => {
	const context = useContext(VisualContext)
	if (context === undefined) {
		throw new Error("useVisual must be used with VisualContext")
	}
	return context
}

export { VisualContext, VisualProvider, visualReducer, useVisualContext } 
